import { $authHost } from ".."

export const addSupplyBillPaymentAPI = async (billPayment) => {
    const {data} = await $authHost.post(`api/supply_bill_payments/`, billPayment)
    return data
}

export const editSupplyBillPaymentAPI = async (billPayment) => {
    const {data} = await $authHost.post(`api/supply_bill_payments/${billPayment.id}`, billPayment)
    return data
}

export const cgangeStatusPaymentSupplyBillAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_payments/change_status/${dataForBd.id}`, dataForBd)
    return data
}